import { css } from '@emotion/react'

import { theme } from '@mindfulchefuk/design-system'

export const onboardingCalendarStyles = css`
  .react-calendar__tile--active abbr,
  .react-calendar__tile--active:hover abbr {
    background-color: ${theme.colors.aubergine};
    color: ${theme.colors.white};
    ${theme.typography['body-lg-500']}
  }
`
